import { BvTableField } from 'bootstrap-vue';
import { ColumnsModel } from '../models';

export const FilterDefaults = {
  Debounce: 400,
  ElementId: 'searchbox-input',
  ContainerElementId: 'searchbox-container'
};

export const TableStateFields = {
  CurrentPage: 'currentPage',
  ItemsPerPage: 'itemsPerPage',
  SearchQuery: 'searchQuery',
  SortBy: 'sortBy',
  SortDesc: 'sortDesc',
  SelectedPk: 'selectedPk'
};

export const DefaultFieldDefinitions = {
  Actions: {
    key: 'actions',
    label: '',
    thStyle: { width: 0 }
  } as { key: string } & BvTableField
};

export const DefaultFilterOptions = {
  Any: {
    key: 'any',
    label: 'Any'
  } as ColumnsModel
};
